import type { PayloadAction } from '@reduxjs/toolkit';
import type { EditorState } from './state';
import type { QuizHeaderSettings } from '@/components/quiz-runtime/quizHeader';
import { withQuizHeader } from './appearanceEdits';

/**
 * Шапка квиза своими полями (слово владельца 20.10.2026): тело действия
 * `setQuizHeader`. Правка одного поля не трогает соседние; `undefined` (и
 * пустой адрес) снимает поле — «как в стиле»; снято последнее или пришёл
 * `null` — поля `quizHeader` в настройках нет вовсе (отсутствие = прежняя
 * шапка пака).
 *
 * Живёт здесь, а не в editorSlice.ts: фасад держит храповик длины (WEB-2552,
 * FACADE_MAX_LINES в store/__tests__/editorSlice.test.ts). Создатель действия
 * и регистрация — `./screenFieldActions.ts`, имя `editor/setQuizHeader`.
 * Правило правки — `withQuizHeader` (`./appearanceEdits.ts`, WEB-3767): та же
 * дверь у окна «Оформление» для части, которой нет в хранилище.
 */
export type QuizHeaderPatch = {
  [K in keyof QuizHeaderSettings]?: QuizHeaderSettings[K] | undefined;
};

export function setQuizHeaderReducer(
  state: EditorState,
  action: PayloadAction<QuizHeaderPatch | null>,
): EditorState {
  return {
    ...state,
    settings: withQuizHeader(state.settings, action.payload),
    isDirty: true,
  };
}
